import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { TaxedMoney } from "@components/containers";
import { orderDetailsUrl } from "@temp/app/routes/paths";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import Media from "react-media";
import { Route } from "react-router-dom";
import { ThemeContext } from "styled-components";
import classNames from "classnames";
import { OrderDetails } from "../../../../userAccount/views";
import * as S from "./styles";
// const header = (
//   matches: boolean,
//   startScroll: boolean,
//   endScroll: boolean,
//   onClickLeftArrow: () => void,
//   onClickRightArrow: () => void
// ): React.ReactElement => (
//   <S.HeaderRow>
//     <S.ArrowLeft onClick={() => onClickLeftArrow()} startScroll={startScroll} />
//     <S.IndexNumber>Number</S.IndexNumber>
//     <>
//       <S.DateOfOrder>Date</S.DateOfOrder>
//       <S.Status>Status</S.Status>
//       <S.Address>Shipping Address</S.Address>
//       <S.Address>Billing Address</S.Address>
//       <S.Value>Total Price</S.Value>
//       <S.Invoice>Invoice</S.Invoice>
//       <S.Details endScroll={endScroll}>Details</S.Details>
//     </>
//     <S.ArrowRight onClick={() => onClickRightArrow()} endScroll={endScroll} />
//   </S.HeaderRow>
// );
export var OrderTabel = function OrderTabel(_ref) {
  var orders = _ref.orders,
      history = _ref.history,
      match = _ref.match;
  var intl = useIntl();
  var theme = React.useContext(ThemeContext);

  var toggleOrderDetails = function toggleOrderDetails(token, e) {
    var position = e.currentTarget.getBoundingClientRect();
    var topSpace = (window.pageYOffset || e.currentTarget.scrollTop) - (e.currentTarget.clientTop || 0);
    var orderPath = "/my-orders/".concat(token);
    var isCurrentOrderPath = history.location.pathname === orderPath;
    history.push(isCurrentOrderPath ? "/my-orders/" : orderPath);
    window.scrollTo(0, position.top + topSpace - 160);
  };

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      scroll = _useState2[0],
      setScroll = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      endScroll = _useState4[0],
      setEndScroll = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      startScroll = _useState6[0],
      setStartScroll = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      maxWidth = _useState8[0],
      setMaxWidth = _useState8[1];

  var handleScroll = function handleScroll(e) {
    var scrollLeft = e.currentTarget.scrollLeft;
    setScroll(scrollLeft);
  };

  var onClickLeftArrow = function onClickLeftArrow() {
    setScroll(scroll - scrollElementsRef.current[0].offsetWidth);
  };

  var onClickRightArrow = function onClickRightArrow() {
    setScroll(scroll + scrollElementsRef.current[0].offsetWidth);
  };

  var scrollElementsRef = useRef();
  useEffect(function () {
    scrollElementsRef.current = document.querySelectorAll(".order-scroll-element");
    var orderPath = "/my-orders/".concat(orders[0].node.token);
    var isCurrentOrderPath = history.location.pathname === orderPath;
    history.push(isCurrentOrderPath ? "/my-orders/" : orderPath);
  }, []);
  useEffect(function () {
    if (scrollElementsRef.current) {
      scrollElementsRef.current.forEach(function (el) {
        el.scrollLeft = scroll;
      });
    }

    var start = scrollElementsRef.current[0].scrollLeft;
    scrollElementsRef.current[0].scrollLeft = scrollElementsRef.current[0].scrollWidth;
    var max = scrollElementsRef.current[0].scrollLeft;
    scrollElementsRef.current[0].scrollLeft = start;
    setMaxWidth(max);
    setEndScroll(scroll === maxWidth);
    setStartScroll(scroll > 1);
  }, [scroll, maxWidth, startScroll, endScroll]);
  return React.createElement(S.Wrapper, null, React.createElement(S.BorderLeft, {
    startScroll: startScroll
  }), React.createElement(Media, {
    query: {
      minWidth: theme.breakpoints.largeScreen
    }
  }, function (matches) {
    return React.createElement(React.Fragment, null, React.createElement("div", {
      onScroll: handleScroll,
      className: "order-scroll-element"
    }, React.createElement(S.Row, null, React.createElement(S.HeaderRow, null, React.createElement(S.ArrowLeft, {
      onClick: function onClick() {
        return onClickLeftArrow();
      },
      startScroll: startScroll
    }), React.createElement(S.IndexNumber, null, intl.formatMessage(_defineProperty({
      defaultMessage: "Number",
      "id": "@next.components.molecules.OrderTabel.OrderTabel.4055045245"
    }, "id", "@next.components.molecules.OrderTabel.OrderTabel.4055045245"))), React.createElement(React.Fragment, null, React.createElement(S.DateOfOrder, null, intl.formatMessage(_defineProperty({
      defaultMessage: "Date",
      "id": "@next.components.molecules.OrderTabel.OrderTabel.4205493358"
    }, "id", "@next.components.molecules.OrderTabel.OrderTabel.4205493358"))), React.createElement(S.Status, null, intl.formatMessage(_defineProperty({
      defaultMessage: "Status",
      "id": "@next.components.molecules.OrderTabel.OrderTabel.1756106276"
    }, "id", "@next.components.molecules.OrderTabel.OrderTabel.1756106276"))), React.createElement(S.Address, null, intl.formatMessage(_defineProperty({
      defaultMessage: "Shipping Address",
      "id": "@next.components.molecules.OrderTabel.OrderTabel.2758581442"
    }, "id", "@next.components.molecules.OrderTabel.OrderTabel.2758581442"))), React.createElement(S.Address, null, intl.formatMessage(_defineProperty({
      defaultMessage: "Billing Address",
      "id": "@next.components.molecules.OrderTabel.OrderTabel.4282475982"
    }, "id", "@next.components.molecules.OrderTabel.OrderTabel.4282475982"))), React.createElement(S.Value, null, intl.formatMessage(_defineProperty({
      defaultMessage: "Total Price",
      "id": "@next.components.molecules.OrderTabel.OrderTabel.216202846"
    }, "id", "@next.components.molecules.OrderTabel.OrderTabel.216202846"))), React.createElement(S.Invoice, null, intl.formatMessage(_defineProperty({
      defaultMessage: "Invoice",
      "id": "@next.components.molecules.OrderTabel.OrderTabel.3589949197"
    }, "id", "@next.components.molecules.OrderTabel.OrderTabel.3589949197"))), React.createElement(S.Details, {
      endScroll: endScroll
    }, intl.formatMessage(_defineProperty({
      defaultMessage: "Details",
      "id": "@next.components.molecules.OrderTabel.OrderTabel.928039481"
    }, "id", "@next.components.molecules.OrderTabel.OrderTabel.928039481")))), React.createElement(S.ArrowRight, {
      onClick: function onClick() {
        return onClickRightArrow();
      },
      endScroll: endScroll
    })))), orders && orders.map(function (order) {
      var _order$node = order.node,
          shippingAddress = _order$node.shippingAddress,
          billingAddress = _order$node.billingAddress;
      var date = new Date(order.node.created);
      var ye = new Intl.DateTimeFormat("en", {
        year: "numeric"
      }).format(date);
      var mo = new Intl.DateTimeFormat("en", {
        month: "short"
      }).format(date);
      var da = new Intl.DateTimeFormat("en", {
        day: "2-digit"
      }).format(date);
      return React.createElement(React.Fragment, null, React.createElement("div", {
        onScroll: handleScroll,
        className: classNames("order-scroll-element", {
          open: match && match.params.token === order.node.token
        })
      }, React.createElement(S.Row, {
        "data-testid": "order__row",
        key: order.node.id,
        onClick: function onClick(evt) {
          evt.stopPropagation();
          toggleOrderDetails(order.node.token, evt);
        }
      }, React.createElement(S.IndexNumber, null, order.node.number), React.createElement(S.DateOfOrder, null, da, " ", mo, " ", ye), React.createElement(S.Status, null, order.node.paymentStatusDisplay), React.createElement(S.Address, null, shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.firstName, " ", shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.lastName, (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.lastName) ? ", " : " ", shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.country.country, " ", React.createElement("br", null), shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.postalCode, " ", shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.city, " ", React.createElement("br", null), (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.streetAddress1) && React.createElement(React.Fragment, null, shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.streetAddress1, React.createElement("br", null)), shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.streetAddress2), React.createElement(S.Address, null, billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.firstName, " ", billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.lastName, (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.lastName) ? ", " : " ", billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.country.country, " ", React.createElement("br", null), billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalCode, " ", billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.city, " ", React.createElement("br", null), (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.streetAddress1) && React.createElement(React.Fragment, null, billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.streetAddress1, React.createElement("br", null)), billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.streetAddress2), React.createElement(S.Value, null, React.createElement(TaxedMoney, {
        taxedMoney: order.node.total
      })), React.createElement(S.Invoice, null, intl.formatMessage(_defineProperty({
        defaultMessage: "Download invoice",
        "id": "@next.components.molecules.OrderTabel.OrderTabel.2670827143"
      }, "id", "@next.components.molecules.OrderTabel.OrderTabel.2670827143"))), React.createElement(S.Action, {
        endScroll: endScroll
      }, history.location.pathname === "/my-orders/".concat(order.node.token) ? React.createElement(S.Minus, null) : React.createElement(S.Plus, null)))), match && match.params.token === order.node.token && React.createElement(Route, {
        exact: true,
        path: orderDetailsUrl,
        render: function render(props) {
          return React.createElement(OrderDetails, _extends({}, props, {
            hideFooter: true
          }));
        }
      }));
    }));
  }), React.createElement(S.BorderRight, {
    endScroll: endScroll
  }));
};